export default __webpack_public_path__ + "static/Agua-0b1a34a126993176963e33b9160664b0.jpg";